import { format, addDays, differenceInMinutes, differenceInDays } from 'date-fns'
import { IPincode, IPincodeOption } from 'Models/ResponseModels'
import { IHealthPincode, IHealthPincodeOption } from 'Models/ResponseModels/Health'
import { KeyboardEvent } from 'react'
import { ToastService } from './toast.service'

const IndianRupeeFormatFromString = (num: string) => {
  if (num == '' || num === null) {
    return ''
  }
  return Intl.NumberFormat('en-IN').format(parseInt(num))
}

const onlyAllowTypingNumbers = (e: KeyboardEvent<HTMLInputElement>) => {
  if (!(e.key === 'Backspace' || e.key === 'Tab' || e.key === 'ArrowDown')) {
    if (e.key.charCodeAt(0) < 48 || e.key.charCodeAt(0) > 57) {
      e.preventDefault()
    }
  }
}

const getManufacturingYearArr = (
  startYear: number,
  currentYear: number = new Date().getFullYear(),
): number[] => {
  const arr = []
  for (let year = startYear; year <= currentYear; year++) {
    arr.push(year)
  }
  return arr
}

const getExistingNoClaimBonusArr = (): number[] => {
  return [0, 20, 25, 35, 45, 50]
}

const validateVehicleNumber = (input: string) => {
  input = String(input).replace(/-/g, '').toUpperCase()
  let result = ''
  if (input.length >= 2) {
    const temp = input.slice(0, 2)
    if (!temp.match('[A-Z]$')) {
      return result
    }
    result += temp + '-'
    input = input.slice(2)
    if (input.length) {
      if (!input[0].match('[0-9]$')) {
        return result
      }
      result += input[0]
      input = input.slice(1)

      if (input.length) {
        if (input[0].match('[0-9]$')) {
          result += input[0]
          input = input.slice(1)
        } else if (input[0].match('[A-Z]$') && result.length === 4) {
          result = [result.slice(0, 3), '0', result.slice(3)].join('')
          // input = input.slice(1,)
        }
      }
      result += '-'
      let i = 0
      while (input && i < 3) {
        if (!input[0].match('[A-Z]$')) {
          break
        }
        result += input[0]
        input = input.slice(1)
        i += 1
      }
      if (i) {
        result += '-'
      }
      if (input) {
        const val = input.match(/^([0-9]+)/)
        if (val) {
          result += val[0]?.slice(0, 4)
        }
      }
    }
  } else {
    if (input.match('[A-Z]$')) {
      result += input
    }
  }
  result = result.match('(.+)-$') ? result.slice(0, result.length - 1) : result
  return result
}

const validateVehicleRtoNumber = (input: any) => {
  input = String(input).replace(/-/g, '').toUpperCase()
  let result = ''
  if (input.length >= 2) {
    const temp = input.slice(0, 2)
    if (!temp.match('[A-Z]$')) {
      return result
    }
    result += temp + '-'
    input = input.slice(2)
    if (input.length) {
      if (!input[0].match('[0-9]$')) {
        return result
      }
      result += input[0]
      input = input.slice(1)

      if (input.length) {
        if (input[0].match('[0-9]$')) {
          result += input[0]
          input = input.slice(1)
        }
        result += '-'
      }
    } else {
      if (input.match('[A-Z]$')) {
        result += input
      }
    }
    result = result.match('(.+)-$') ? result.slice(0, result.length - 1) : result
    return result
  }
}

// const validateVehicleRtoNumber = (input: any) => {
//   if (input.length !== 4) {
//     return
//   }
//   const firstTwo = input.substr(0, 2)
//   const lastTwo = input.substr(3)
//   if (isNaN(lastTwo)) {
//     return
//   }
//   for (let i = 0; i < firstTwo.length; i++) {
//     if (firstTwo[i] < 'A' || firstTwo[i] > 'Z') {
//       return
//     }
//   }
//   return input
// }

const checkVehicleNumber = (number: string) => {
  if (number) {
    const str = number.split('-')
    if (str.length) {
      if (str[str.length - 1].length < 4) {
        return false
      }
    }
    return number.length >= 10
  }
}
const onlyAllowTypingAlphabet = (e: KeyboardEvent<HTMLInputElement>) => {
  if (
    (e.key.charCodeAt(0) > 64 && e.key.charCodeAt(0) < 91) ||
    (e.key.charCodeAt(0) > 96 && e.key.charCodeAt(0) < 123) ||
    e.key == ' '
  ) {
    console.log('')
  } else {
    e.preventDefault()
  }
}

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text)
  ToastService.showSuccessTaost({ title: 'Copied to clipboard!' })
}

const getAgeFromDob = (dob: Date) => {
  const dobInNumber = +dob
  const todaysDate = +new Date()
  const ageInSeconds = todaysDate - dobInNumber
  return ageInSeconds / (24 * 3600 * 365.25 * 1000)
}

const getDOBfromAge = (age: string) => {
  const dob = new Date().getFullYear() - parseInt(age)
  return dob.toString() + '-01-01'
}
const getMemberTypeFromAge = (age: string) => {
  let type = ''
  if (parseInt(age) >= 18) {
    type = 'adult'
  } else {
    type = 'child'
  }
  return type
}

const getDateFromDDMMYYYY = (dateInDDMMYYYY: string) => {
  const dateArr = dateInDDMMYYYY.split('/')
  const dateToBePassedInConstructor = `${dateArr[1]}/${dateArr[0]}/${dateArr[2]}`
  return new Date(dateToBePassedInConstructor)
}

const getRegistrationDateFromManufacturingYear = (year: number | string) => {
  year = year.toString()
  if (year.length !== 4) {
    throw Error('Invalid Year')
  }
  const currentDate = new Date()
  const firstDateOfTwoYearsForwardYear = new Date(`${parseInt(year) + 2}/1/1`)
  console.log(differenceInMinutes(currentDate, firstDateOfTwoYearsForwardYear))
}

const pincodeLabelFormatter = (pincodesArray: IPincode[]) => {
  return pincodesArray.map((pincode) => {
    return {
      ...pincode,
      value: pincode.area,
      label: `${pincode.area_name}(${pincode.pincode})`,
    }
  })
}
const pincodeLabelFormatterHealth = (pincodesArray: IHealthPincode[]) => {
  return pincodesArray.map((pincode) => {
    return {
      ...pincode,
      value: pincode.area_code.toString(),
      label: `${pincode.area_name}(${pincode.pincode})`,
    }
  })
}
const getArrayFromObj = (obj: any) => {
  if (!obj) return []
  return Object.keys(obj).map((key) => {
    return {
      ...obj[key],
      key: key,
    }
  })
}

const getExistingPolicyExpMinDate = (registrationDate: string, isSaod: boolean) => {
  const registrationDateInDateFormat = getDateFromDDMMYYYY(registrationDate)
  if (registrationDateInDateFormat) {
    if (isSaod === true) {
      if (registrationDateInDateFormat && registrationDateInDateFormat.getFullYear() > 2018) {
        return new Date(`${registrationDateInDateFormat.getFullYear()}/01/01`)
      }
      return registrationDateInDateFormat ?? new Date()
    } else {
      return new Date(`${new Date().getFullYear() - 2}/01/01`)
    }
  }
}

const getTpPolicyEndMinDate = (policyExpDate: string) => {
  console.log('policyExpDate - ', policyExpDate)
  if (policyExpDate) {
    const policyExpDateInDateFormat = getDateFromDDMMYYYY(policyExpDate)
    return addDays(policyExpDateInDateFormat, 365)
  }
}

const calculateBMI = (height: number, weight: number) => {
  height = height / 100
  const bmi = weight / (height * height)
  return bmi.toFixed(2)
}

export {
  IndianRupeeFormatFromString,
  onlyAllowTypingNumbers,
  onlyAllowTypingAlphabet,
  getManufacturingYearArr,
  getExistingNoClaimBonusArr,
  validateVehicleNumber,
  checkVehicleNumber,
  copyToClipboard,
  getAgeFromDob,
  getMemberTypeFromAge,
  getDOBfromAge,
  pincodeLabelFormatter,
  getDateFromDDMMYYYY,
  pincodeLabelFormatterHealth,
  getRegistrationDateFromManufacturingYear,
  getArrayFromObj,
  getExistingPolicyExpMinDate,
  getTpPolicyEndMinDate,
  calculateBMI,
  validateVehicleRtoNumber,
}
